import React from 'react';
import styles from './ChestSalePage.module.scss';
import { ChestSale } from '../../components';

const ChestSalePage = () => {
    window.scrollTo(0, 0);
    
    return (
        <>
            <div className={styles.chest_sale_container}>
                <ChestSale />
            </div>
        </>
    );
};

export { ChestSalePage };